import React from 'react';


const Search = (props) => (
    <div className="input-group presuffix">
        <label for="search-field" className="input-group-addon prefix">&#x1F50D;</label>
        <input
            type="text"
            id="search-field"
            onChange={(evt) => props.update(evt.target.value)}
            value={props.query} 
            placeholder="Your search term here"
            />
        <span className="input-group-addon suffix" onClick={()=> props.update("")}>&times;</span>                
    </div>
)
export default Search


// WEBPACK FOOTER //
// ./src/components/search.js